// extracted by mini-css-extract-plugin
export default {"container":"InstallmentsSimulation_container__IPEP-"};